import React from 'react';
import { AppBar, Button, ButtonProps, Link, Stack, styled, Toolbar } from '@mui/material';
import { applicationLanguageState, tenantInfoState } from 'modules/application/atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { languageDetails, SupportedLocales } from 'modules/application/types';
import { setBrowserLocale } from 'utils/locales';
import { getFirstSegment } from 'utils/urls';

const LanguageButton = styled(Button)<ButtonProps>(() => ({
  minWidth: 'initial'
}));


export const TopAppBar = () => {
  const [applicationLanguage, setApplicationLanguage] = useRecoilState(applicationLanguageState);
  const tenantInfo = useRecoilValue(tenantInfoState);

  const logoLink = `/${tenantInfo.identifier === getFirstSegment() ? tenantInfo.identifier : ''}`;
  const otherLanguages = languageDetails.filter(l => l.key !== applicationLanguage);
  const onLanguageButtonClick = (language: SupportedLocales) => {
    setApplicationLanguage(language);
    setBrowserLocale(language);
  };


  return (
    <AppBar color='default' position='sticky' elevation={3}>
      <Toolbar>
        <Stack flexGrow={1} direction='row' justifyContent="space-between" alignItems="center" py={1} gap={1}>
          <Stack flexGrow={1} direction='row' sx={{ height: { xs: 40, sm: 60 } }}>
            <Link href={logoLink} sx={{ display: 'contents' }}>
              <img src={`/${tenantInfo.identifier}/api/tenants/me/logo.png`} />
            </Link>
          </Stack>
          {
            otherLanguages.map(language => (
              <LanguageButton key={language.key} name={language.description} variant='text' onClick={() => onLanguageButtonClick(language.key)}>{language.title}</LanguageButton>
            ))
          }
        </Stack>
      </Toolbar>
    </AppBar>
  );
};